import {Routes} from '@angular/router';

/** Components */
import {CodeSearchComponent} from './code-search/code-search.component';
/** Resolvers */
import {SlackConnectRedirectComponent} from './access-change-monitoring/components/slack-connect-redirect/slack-connect-redirect.component';
import {CodeSearchLoadingComponent} from './code-search/components/code-search-loading/code-search-loading.component';
import {CodeSearchViewComponent} from './code-search/components/code-search-view/code-search-view.component';
import {AuthGuard} from './core/guards/auth.guard';
import {changeMonitoringLicenseGuard} from './core/guards/change-monitoring-license.guard';
import {ImpactAssessmentResolve} from './core/resolvers/impact-assessment.resolver';
import {LicenseResolve} from './core/resolvers/license.resolver';
import {NodePathResolve} from './core/resolvers/node-path.resolver';
import {RefModelMetaResolve} from './core/resolvers/ref-model-meta.resolver';
import {UserResolve} from './core/resolvers/user.resolver';
import {EditorInterfaceComponent} from './editor-interface/editor-interface.component';
import {LicenseErrorComponent} from './error-pages/license-error/license-error.component';
import {NotFoundComponent} from './error-pages/not-found/not-found.component';
import {ImpactAssessmentComponent} from './impact-assessment/impact-assessment.component';
import {ImpactGridViewComponent} from './impact-grid-view/impact-grid-view.component';

export const appRoutes: Routes = [
  {
    path: 'slack/connect/redirect',
    canActivate: [AuthGuard],
    component: SlackConnectRedirectComponent
  },
  {
    path: 'refmodel/:refModelId',
    canActivate: [AuthGuard],
    data: {requiredLicenseFlag: 'systemModels'},
    resolve: {
      user: UserResolve,
      refModelMeta: RefModelMetaResolve,
      nodePath: NodePathResolve,
      license: LicenseResolve
    },
    component: EditorInterfaceComponent,
    children: [
      {
        path: 'customView/:customViewId',
        canActivate: [AuthGuard],
        resolve: {
          user: UserResolve,
          refModelMeta: RefModelMetaResolve,
          nodePath: NodePathResolve
        },
        component: EditorInterfaceComponent
      },
      {
        path: 'customView/:customViewId/standard',
        canActivate: [AuthGuard],
        resolve: {
          user: UserResolve,
          refModelMeta: RefModelMetaResolve,
          nodePath: NodePathResolve
        },
        component: EditorInterfaceComponent
      },
      {
        path: 'qc/:qcViewId',
        canActivate: [AuthGuard],
        resolve: {
          user: UserResolve,
          refModelMeta: RefModelMetaResolve,
          nodePath: NodePathResolve
        },
        component: EditorInterfaceComponent
      }
    ]
  },
  {
    path: 'refmodel/:refModelId/monitoring',
    canActivate: [AuthGuard, changeMonitoringLicenseGuard],
    resolve: {
      refModelMeta: RefModelMetaResolve
    },
    loadChildren: () =>
      import('./access-change-monitoring/access-change-monitoring.module').then(
        m => m.AccessChangeMonitoringModule
      )
  },
  {
    path: 'adoption-center/:refModelId',
    canActivate: [AuthGuard],
    resolve: {
      refModelMeta: RefModelMetaResolve
    },
    loadChildren: () =>
      import('./adoption-center/adoption-center.module').then(m => m.AdoptionCenterModule)
  },
  {
    path: 'architecture-explorer/:refModelId',
    canActivate: [AuthGuard],
    resolve: {
      refModelMeta: RefModelMetaResolve
    },
    loadChildren: () =>
      import('./architecture-explorer/architecture-explorer.module').then(
        m => m.ArchitectureExplorerModule
      )
  },
  {
    path: 'code-search/:refModelId',
    canActivate: [AuthGuard],
    resolve: {
      license: LicenseResolve,
      refModel: RefModelMetaResolve
    },
    data: {requiredLicenseFlag: 'orgDependencyExplorer'},
    component: CodeSearchComponent,
    children: [
      {
        path: `loading`,
        component: CodeSearchLoadingComponent
      },
      {
        path: `result`,
        component: CodeSearchViewComponent
      }
    ]
    // loadChildren: () => import('./code-search/code-search.module').then(m => m.CodeSearchModule)
  },
  //OLD_ANALYTICS will be removed in the future
  // {
  //   path: 'sf-analytics/:refModelId',
  //   canActivate: [AuthGuard],
  //   resolve: {
  //     user: UserResolve,
  //     sfAnalytics: SfAnalyticsResolve
  //   },
  //   component: SfAnalyticsComponent
  // },
  {
    path: 'sf-impact-assessment/:refModelId/:nodeId',
    canActivate: [AuthGuard],
    resolve: {
      license: LicenseResolve,
      nodePath: NodePathResolve,
      refModelMeta: RefModelMetaResolve,
      impactAssessmentResolve: ImpactAssessmentResolve
    },
    data: {requiredLicenseFlag: 'orgDependencyExplorer'},
    component: ImpactAssessmentComponent
  },
  {
    path: 'impact-grid-view/:refModelId',
    canActivate: [AuthGuard],
    resolve: {
      license: LicenseResolve,
      refModelMeta: RefModelMetaResolve
    },
    data: {requiredLicenseFlag: 'orgDependencyExplorer'},
    component: ImpactGridViewComponent
  },
  {path: 'license-error', component: LicenseErrorComponent},
  {path: '**', component: NotFoundComponent}
];
